import React from 'react'
import ArenaTable from './ArenaTable';
import { TableObject } from './TableObject';

export default function Arena77Table({ totalTables, toggleTableSelection, BaseURL, translate }) {
    return <div className="bookingTableContainer" style={{ width: 1000, }}>

        <div className="bookingTableCenter">

            <div className="BookingTableArena">
                <img
                    style={{ background: '#A67B52', marginLeft: 5 }}
                    src={`${BaseURL}/assets/img/HorseArena56.png`}
                    alt="Horse Arena" />
            </div>
        </div>
        <div className="bookingTablesRow withVIPSection mt-3" style={{ marginLeft: -125 }}>
            {totalTables
                .filter((item, index) => item.tableNo > 7 && item.tableNo < 15)
                .map((item, index) => (
                    index < 7 &&
                    <ArenaTable
                        key={item.tableNo}
                        tableNumber={item.tableNo}
                        tablePrice={item.price}
                        renderPrice
                        state={TableObject.fromRaw(item).state()}
                        onClick={() => toggleTableSelection(item.id, item.price)} />
                ))}
            <div className="vipSection">{translate('web.vvipPlatForm', 'VVIP Platform')}</div>
            {totalTables

                .filter((item, index) => item.tableNo < 8)
                .map((item, index) => (
                    index < 7 &&
                    <ArenaTable
                        key={item.tableNo}
                        tableNumber={item.tableNo}
                        renderPrice
                        tablePrice={item.price}
                        state={TableObject.fromRaw(item).state()}
                        onClick={() => toggleTableSelection(item.id, item.price)} />
                ))}
        </div>
        <div className="bookingTablesRow withVIPSection secondVIPRow" style={{ marginLeft: -175 }}>
            {totalTables

                .filter((item, index) => item.tableNo > 21 && item.tableNo < 29)
                .map((item, index) => (
                    index < 7 &&
                    <ArenaTable
                        renderPrice
                        key={item.tableNo}
                        tableNumber={item.tableNo}
                        tablePrice={item.price}
                        state={TableObject.fromRaw(item).state()}
                        onClick={() => toggleTableSelection(item.id, item.price)} />
                ))}
            <div className="vipSection">{translate('web.vvipPlatForm', 'VVIP Platform')}</div>
            {totalTables
                .filter((item, index) => item.tableNo > 14 && item.tableNo < 22)
                .map((item, index) => (
                    index < 7 &&
                    <ArenaTable
                        renderPrice
                        key={item.tableNo}
                        tableNumber={item.tableNo}
                        tablePrice={item.price}
                        state={TableObject.fromRaw(item).state()}
                        onClick={() => toggleTableSelection(item.id, item.price)} />
                ))}
        </div>
        <div className="bookingTablesRow withVIPSection secondVIPRow" style={{ marginLeft: -175 }}>
            {totalTables

                .filter((item, index) => item.tableNo > 35 && item.tableNo < 43)
                .map((item, index) => (
                    index < 7 &&
                    <ArenaTable
                        renderPrice
                        key={item.tableNo}
                        tableNumber={item.tableNo}
                        tablePrice={item.price}
                        state={TableObject.fromRaw(item).state()}
                        onClick={() => toggleTableSelection(item.id, item.price)} />
                ))}
            <div className="vipSection">{translate('web.vvipPlatForm', 'VVIP Platform')}</div>
            {totalTables
                .filter((item, index) => item.tableNo > 28 && item.tableNo < 36)
                .map((item, index) => (
                    index < 7 &&
                    <ArenaTable
                        renderPrice
                        key={item.tableNo}
                        tableNumber={item.tableNo}
                        tablePrice={item.price}
                        state={TableObject.fromRaw(item).state()}
                        onClick={() => toggleTableSelection(item.id, item.price)} />
                ))}
        </div>
        <div className="bookingTablesRow withVIPSection secondVIPRow" style={{ marginLeft: -175 }}>
            {totalTables

                .filter((item, index) => item.tableNo > 49 && item.tableNo < 57)
                .map((item, index) => (
                    index < 7 &&
                    <ArenaTable
                        renderPrice
                        key={item.tableNo}
                        tableNumber={item.tableNo}
                        tablePrice={item.price}
                        state={TableObject.fromRaw(item).state()}
                        onClick={() => toggleTableSelection(item.id, item.price)} />
                ))}
            <div className="vipSection">{translate('web.vvipPlatForm', 'VVIP Platform')}</div>
            {totalTables
                .filter((item, index) => item.tableNo > 42 && item.tableNo < 50)
                .map((item, index) => (
                    index < 7 &&
                    <ArenaTable
                        renderPrice
                        key={item.tableNo}
                        tableNumber={item.tableNo}
                        tablePrice={item.price}
                        state={TableObject.fromRaw(item).state()}
                        onClick={() => toggleTableSelection(item.id, item.price)} />
                ))}
        </div>
    </div>;
}
